import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'

import { prepareData } from 'helpers/prepare-req-data'
import { prepParams } from 'helpers/prep-req-url'
import { getRespData  } from 'helpers/get-resp-data'
import client from 'api'
import _ from 'lodash'

import { v4 as uuid4 } from 'uuid'


const initialState = {
    loadTOMerkmalDefListStatus: 'idle',
    loadTOMerkmalDefListError: undefined as any,
    loadTOMerkmalDefListLastArgs: undefined as any,
    loadTOMerkmalDefStatus: 'idle',
    loadTOMerkmalDefError: undefined as any,
    saveTOMerkmalDefStatus: 'idle',
    saveTOMerkmalDefError: undefined as any,
    deleteTOMerkmalDefStatus: 'idle',
    deleteTOMerkmalDefError: undefined as any,

    toMerkmalDefList: [] as any[],
    formItem: undefined as any,
    filterValues: {} as any,
    filterLookupValues: {} as any,

    directLoad: false,
    load: false,
    activeDivRef: null as any,

    filterValuesId: null,
    valuesFromDB: false,
    filterVisibleId: null,
    filterVisible: true,
}


export const loadTOMerkmalDefList = createAsyncThunk('toDefTOMerkmalDefSlice/loadTOMerkmalDefList', async ({ parentModel, forceReload }: any, { rejectWithValue, getState }: any) => {
    const lastArgs = getState().toDefTOMerkmalDefSlice.loadTOMerkmalDefListLastArgs
    if (_.isEqual(lastArgs, { parentModel }) && !forceReload) { return }

    let promises = []
    promises.push(client.get(
        `/api/ixweb/nuristomerkmdef/?action=gte&TODEFID=${parentModel.HDR_ID}`,
    ))

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue)

    return {
        data: value1.map((x: any) => ({
            ...x,
        })),
        args: { parentModel }
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { loadTOMerkmalDefListStatus } = getState().toDefTOMerkmalDefSlice
        return loadTOMerkmalDefListStatus !== 'pending'
    }
})

export const loadTOMerkmalDef = createAsyncThunk('toDefTOMerkmalDefSlice/loadTOMerkmalDef', async ({ id }: any, { rejectWithValue }: any) => {
    let promises = []
    promises.push(client.get(
        `/api/ixweb/nuristomerkmdef/?action=eql&HDR_ID=${id}`,
    ))

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue, true)

    return {
        data: {
            ...value1,
        }
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { loadTOMerkmalDefStatus } = getState().toDefTOMerkmalDefSlice
        return loadTOMerkmalDefStatus !== 'pending'
    }
})

export const saveTOMerkmalDef = createAsyncThunk('toDefTOMerkmalDefSlice/saveTOMerkmalDef', async ({ toMerkmalDef }: any, { rejectWithValue }: any) => {
    let promises = []
    if (toMerkmalDef?.HDR_ID) {
        promises.push(client.put(
            `/api/ixweb/nuristomerkmdef/${ toMerkmalDef?.HDR_ID }/`,
            prepareData(toMerkmalDef),
        ))
    } else {
        promises.push(client.post(
            `/api/ixweb/nuristomerkmdef/`,
            prepareData(toMerkmalDef),
        ))
    }

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue, true)

    return {
        data: {
            ...value1,
        }
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { saveTOMerkmalDefStatus } = getState().toDefTOMerkmalDefSlice
        return saveTOMerkmalDefStatus !== 'pending'
    }
})

export const deleteTOMerkmalDef = createAsyncThunk('toDefTOMerkmalDefSlice/deleteTOMerkmalDef', async ({ id }: any, { rejectWithValue }: any) => {
    let promises = []
    promises.push(client.delete(
        `/api/ixweb/nuristomerkmdef/${id}/`,
    ))

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue)

    return {
        data: id,
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { deleteTOMerkmalDefStatus } = getState().toDefTOMerkmalDefSlice
        return deleteTOMerkmalDefStatus !== 'pending'
    }
})

const ToMerkmalDefSlice = createSlice({
    name: 'toDefTOMerkmalDefSlice',
    initialState,
    reducers: {
        resetloadTOMerkmalDefListError: (state) => {
            state.loadTOMerkmalDefListError = undefined
        },
        resetloadTOMerkmalDef: (state) => {
            state.formItem = undefined
            state.loadTOMerkmalDefError = undefined
        },
        resetloadTOMerkmalDefError: (state) => {
            state.loadTOMerkmalDefError = undefined
        },
        resetsaveTOMerkmalDef: (state) => {
            state.formItem = undefined
            state.saveTOMerkmalDefError = undefined
        },
        resetsaveTOMerkmalDefError: (state) => {
            state.saveTOMerkmalDefError = undefined
        },
        resetdeleteTOMerkmalDefError: (state) => {
            state.deleteTOMerkmalDefError = undefined
        },
        removeFromToMerkmalDefListById: (state, action) => {
            state.toMerkmalDefList = state.toMerkmalDefList.filter((x: any) => x.HDR_ID !== action.payload)
        },
        removeFromToMerkmalDefListByIds: (state, action) => {
            state.toMerkmalDefList = state.toMerkmalDefList.filter((x: any) => action.payload.indexOf(x.HDR_ID) === -1)
        },
        setFilterValues: (state, action) => {
            if (action.payload === undefined || action.payload === null) {
                state.filterValues = {}
            } else {
                state.filterValues = { ...state.filterValues, ...action.payload }
            }
        },
        setFilterLookupValue: (state, action) => {
            const { name, value, formValue } = action.payload
            if (name) {
                state.filterLookupValues[name] = value
                state.filterValues[name] = formValue
            }
        },
        setDirectLoad: (state, action) => { state.directLoad = action.payload },
        setLoad: (state, action) => { state.load = action.payload },
        setActiveDivRef: (state, action) => { state.activeDivRef = action.payload},
        setFilterValuesId: (state, action) => {
            state.filterValuesId = action.payload
        },
        setValuesFromDB: (state, action) => {
            state.valuesFromDB = action.payload
        },
        setFilterVisibleId: (state, action) => {
            state.filterVisibleId = action.payload
        },
        setFilterVisible: (state, action) => {
            state.filterVisible = action.payload
        },
        preloadData: (state, action) => {
            state.toMerkmalDefList = action.payload.map((x: any) => ({ ...x, HDR_ID: uuid4()}))
            state.loadTOMerkmalDefListStatus = 'preloaded'
            state.loadTOMerkmalDefListLastArgs = ''
        },
        clearPreloadedData: (state) => {
            state.toMerkmalDefList = []
            state.loadTOMerkmalDefListStatus = 'idle'
            state.loadTOMerkmalDefListLastArgs = undefined
        },
    },
    extraReducers: builder => {
        builder.addCase(loadTOMerkmalDefList.pending, (state) => {
            state.loadTOMerkmalDefListStatus = 'pending'
            state.loadTOMerkmalDefListError = undefined
        })
        builder.addCase(loadTOMerkmalDefList.fulfilled, (state, action) => {
            state.loadTOMerkmalDefListStatus = 'idle'

            if (!action.payload) { return }

            state.loadTOMerkmalDefListLastArgs = action.payload.args

            {
                state.toMerkmalDefList = action.payload.data

            }
        })
        builder.addCase(loadTOMerkmalDefList.rejected, (state, action) => {
            state.loadTOMerkmalDefListStatus = 'error'
            if (action.error.message !== 'Rejected') {
                state.loadTOMerkmalDefListError = action.error.message
            } else {
                state.loadTOMerkmalDefListError = action.payload
            }
        })

        builder.addCase(loadTOMerkmalDef.pending, (state) => {
            state.loadTOMerkmalDefStatus = 'pending'
            state.loadTOMerkmalDefError = undefined
        })
        builder.addCase(loadTOMerkmalDef.fulfilled, (state, action) => {
            state.loadTOMerkmalDefStatus = 'idle'

            {
                const newItem = Array.isArray(action.payload.data) ? action.payload.data[0] : action.payload.data
                state.formItem = newItem
            }
            {
                const newItem = Array.isArray(action.payload.data) ? action.payload.data[0] : action.payload.data
                const i = state.toMerkmalDefList.findIndex((x: any) => x.HDR_ID === newItem.HDR_ID)
                if (i === -1) { state.toMerkmalDefList.push(newItem) }
                else { state.toMerkmalDefList[i] = { ...state.toMerkmalDefList[i], ...newItem } }
            }
        })
        builder.addCase(loadTOMerkmalDef.rejected, (state, action) => {
            state.loadTOMerkmalDefStatus = 'error'
            if (action.error.message !== 'Rejected') {
                state.loadTOMerkmalDefError = action.error.message
            } else {
                state.loadTOMerkmalDefError = action.payload
            }
        })

        builder.addCase(saveTOMerkmalDef.pending, (state) => {
            state.saveTOMerkmalDefStatus = 'pending'
            state.saveTOMerkmalDefError = undefined
        })
        builder.addCase(saveTOMerkmalDef.fulfilled, (state, action) => {
            state.saveTOMerkmalDefStatus = 'idle'

            {
                const newItem = Array.isArray(action.payload.data) ? action.payload.data[0] : action.payload.data
                state.formItem = newItem
            }
            {
                const newItem = Array.isArray(action.payload.data) ? action.payload.data[0] : action.payload.data
                const i = state.toMerkmalDefList.findIndex((x: any) => x.HDR_ID === newItem.HDR_ID)
                if (i === -1) { state.toMerkmalDefList.push(newItem) }
                else { state.toMerkmalDefList[i] = { ...state.toMerkmalDefList[i], ...newItem } }
            }
        })
        builder.addCase(saveTOMerkmalDef.rejected, (state, action) => {
            state.saveTOMerkmalDefStatus = 'error'
            if (action.error.message !== 'Rejected') {
                state.saveTOMerkmalDefError = action.error.message
            } else {
                state.saveTOMerkmalDefError = action.payload
            }
        })

        builder.addCase(deleteTOMerkmalDef.pending, (state) => {
            state.deleteTOMerkmalDefStatus = 'pending'
            state.deleteTOMerkmalDefError = undefined
        })
        builder.addCase(deleteTOMerkmalDef.fulfilled, (state, action) => {
            state.deleteTOMerkmalDefStatus = 'idle'

            {
                if (Array.isArray(action.payload.data)) {
                    state.toMerkmalDefList = state.toMerkmalDefList.filter((x: any) => !action.payload.data.includes(x.HDR_ID))
                } else {
                    state.toMerkmalDefList = state.toMerkmalDefList.filter((x: any) => x.HDR_ID !== action.payload.data)
                }
            }
        })
        builder.addCase(deleteTOMerkmalDef.rejected, (state, action) => {
            state.deleteTOMerkmalDefStatus = 'error'
            if (action.error.message !== 'Rejected') {
                state.deleteTOMerkmalDefError = action.error.message
            } else {
                state.deleteTOMerkmalDefError = action.payload
            }
        })

    }
})

export const {
    resetloadTOMerkmalDefListError,
    resetloadTOMerkmalDef,
    resetloadTOMerkmalDefError,
    resetsaveTOMerkmalDef,
    resetsaveTOMerkmalDefError,
    resetdeleteTOMerkmalDefError,
    removeFromToMerkmalDefListById,
    removeFromToMerkmalDefListByIds,
    setFilterValues,
    setFilterLookupValue,
    setDirectLoad,
    setLoad,
    setActiveDivRef,
    setFilterValuesId,
    setValuesFromDB,
    setFilterVisible,
    setFilterVisibleId,
    preloadData,
    clearPreloadedData,
} = ToMerkmalDefSlice.actions
export default ToMerkmalDefSlice.reducer
